export class PostNLService {
  static async fetchPostNLCollectionPoints(
    Latitude: number = 52.161744,
    Longitude: number = 4.528659,
    CountryCode: string = "NL"
  ) {
    try{
    const res = await useAjaxServer('/api/postnl', {
      query: {
        Latitude,
        Longitude,
        CountryCode,
      },
    });
    if (res.Error) {
      throw new Error("No Post-NL collection point found");
    }
    return res;
  }
  catch (err){
    const { $customClientErrorHandler } = useNuxtApp();
    let errorMeta = { postnlServiceError: true}
        $customClientErrorHandler(
            err,
            'high',
            'PostnlServiceError - trying to fetch postnl collection point using fetchPostNLCollectionPoints()',
            errorMeta
        );
        throw err
  }
  }
}
